export const FALLBACK_CURRENT_SLIDE_INDEX = -1;
export const FALLBACK_SLIDE_COUNT = 0;
